import { Injectable } from '@angular/core';
import { ModalService } from './modal.service';
import { LogService } from './log.service';
import { MessageService } from './message.service';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  constructor(
    private modal: ModalService,
    private log: LogService,
    private message: MessageService
  ) {}

  // open(message: string, onAccept: Function, onReject?: Function) {
  //   const result = window.confirm(message);
  //   if (result) {
  //     onAccept();
  //   } else {
  //     if (onReject) {
  //       onReject();
  //     }
  //   }
  // }

  open(
    message: string,
    confirmText: string,
    rejectText: string,
    onAccept: Function,
    onReject?: Function
  ) {
    this.modal.open(
      ConfirmDialogComponent,
      null,
      () => {
        this.log.trace('ConfirmDialogService.onAccept');
        onAccept();
      },
      () => {
        this.log.trace('ConfirmDialogService.onReject');
        if (onReject) {
          onReject();
        }
      }
    );
    confirmText = confirmText ? confirmText : 'Yes';
    rejectText = rejectText ? rejectText : 'No';
    this.message.postMessage({
      type: 'confirm-dialog',
      message,
      confirmText,
      rejectText
    });
  }
}
